/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback, useEffect, useState } from 'react';
import { Box, Grid, Tab } from '@mui/material';
import { CheckBoxComp, ChipStatus, DialogForm, IChipsSettingProps, IDialogActions, ISnackbarAlert, SelectField, SnackbarAlert, TextFieldInput, TextFieldReadOnly } from '../../../shared/components';
import { GenericService } from '../../../shared/services';
import { ListId, LocalStorange } from '../../../shared/environment';
import { VacancyDTO, UserDTO, ValueListDTO, CompanyFilterDTO, UserFilterDTO, PeopleFilterDTO, AccessRoleDTO, AccessRoleFilterDTO } from '../../../shared/interfaces';
import { formatDate, formatDateTime } from '../../../shared/utils';
import { CompanyDTO } from '../../../shared/interfaces/corpSphere/CompanyDTO';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { DynamicComboBoxPair } from './DynamicComboBoxPair';
import { useTranslation } from 'react-i18next';

interface IVacancyMaintenanceProps {
    data: any;
    parentId?: string;
    setIsOpenMaintenance: (value: boolean) => void;
    isOpenMaintenance: boolean;
    setActionExecuted: (value: boolean) => void;
}

export const VacancyMaintenance: React.FC<IVacancyMaintenanceProps> = ({ data, isOpenMaintenance, setIsOpenMaintenance, setActionExecuted }) => {
    const [companyList, setCompanyList] = useState<CompanyDTO[]>([]);
    const [requesterList, setRequesterList] = useState<UserDTO[]>([]);
    const [managerList, setManagerList] = useState<UserDTO[]>([]);
    const [recruiterList, setRecruiterList] = useState<UserDTO[]>([]);
    const [statusList, setStatusList] = useState<ValueListDTO[]>([]);
    const [jobTitleList, setJobTitleList] = useState<ValueListDTO[]>([]);
    const [seniorityList, setSeniorityList] = useState<ValueListDTO[]>([]);
    const [typeList, setTypeList] = useState<ValueListDTO[]>([]);
    const [contractPeriodList, setContractPeriodList] = useState<ValueListDTO[]>([]);
    const [frequencyList, setFrequencyList] = useState<ValueListDTO[]>([]);
    const [serviceTypeList, setServiceTypeList] = useState<ValueListDTO[]>([]);
    const [hiringTypeList, setHiringTypeList] = useState<ValueListDTO[]>([]);
    const [workTypeList, setWorkTypeList] = useState<ValueListDTO[]>([]);
    const [serviceLocalList, setServiceLocalList] = useState<ValueListDTO[]>([]);
    const [userList, setUserList] = useState<UserDTO[]>([]);
    const [vacancyDTO, setVacancyDTO] = useState<VacancyDTO>();

    const [loading, setLoading] = useState(false);
    const [snackBarAlert, setSnackBarAlert] = useState<ISnackbarAlert>();
    const [isOpenMessage, setIsOpenMessage] = useState(false);

    const [value, setValue] = React.useState('1');

    const [accessRolePermissionDTO, setAccessRolePermissionDTO] = useState<AccessRoleDTO>();
    const userInfo = JSON.parse(localStorage.getItem(LocalStorange.USERINFO) || '');
    const { t } = useTranslation();

    useEffect(() => {
        setVacancyDTO({
            ...vacancyDTO,
            id: '',
            code: '00000',
            externalCode: '',
            statusId: ListId.talentsphere.vacancy.status.newRequestId,
            numberOfVacancies: 1,
            managerId: '',
            requesterId: '',
            recruiterId: '',
            seniorityId: '',
            contractPeriodId: '',
            serviceLocalId: '',
            frequencyId: '',
            workTypeId: '',
            serviceTypeId: '',
            typeId: '',
            hiringTypeId: '',
            startHiring: new Date(),
            openingDateTime: new Date(),
            closingDateTime: new Date(),
            hasBehavioralTest: true,
            hasTechnicalTest: true,
            hasSituationalTest: true
        } as VacancyDTO);

    }, [data]);

    useEffect(() => {
        if (isOpenMaintenance && vacancyDTO?.id != '') {
            handleCompanyGetAll();
            handleListGetAll(ListId.talentsphere.vacancy.statusId, setStatusList, 'valueIndex');
            handleListGetAll(ListId.talentsphere.vacancy.jobTitleId, setJobTitleList);
            handleListGetAll(ListId.talentsphere.vacancy.seniorityId, setSeniorityList);
            handleListGetAll(ListId.talentsphere.vacancy.contractPeriodId, setContractPeriodList);
            handleListGetAll(ListId.talentsphere.vacancy.serviceTypeId, setServiceTypeList);
            handleListGetAll(ListId.talentsphere.vacancy.typeId, setTypeList);
            handleListGetAll(ListId.talentsphere.vacancy.hiringTypeId, setHiringTypeList);
            handleListGetAll(ListId.talentsphere.vacancy.workTypeId, setWorkTypeList);
            handleListGetAll(ListId.talentsphere.vacancy.serviceLocalId, setServiceLocalList);
            handleListGetAll(ListId.talentsphere.vacancy.frequencyId, setFrequencyList);
            handleServiceManagerGetAllAsync();
            handleRecruiterGetAllAsync();
            handlerUserGetAllAsync(setUserList);
            handleGetVacancyByIdAsync();

            handleGetPermission(ListId.talentsphere.vacancyId, setAccessRolePermissionDTO);
        }
        setValue('1');
    }, [data, isOpenMaintenance]);

    useEffect(() => {
        handleRequesterGetAllAsync();
    }, [vacancyDTO?.companyId]);

    useEffect(() => {
        if (vacancyDTO?.companyId) {
            setVacancyDTO({
                ...vacancyDTO,
                name: vacancyDTO.name ?? companyList.find(x => x.id === vacancyDTO?.companyId)?.name + ' [' + jobTitleList.find(x => x.id === vacancyDTO?.jobTitleId)?.value + ' - ' + seniorityList.find(x => x.id === vacancyDTO?.seniorityId)?.value + ']',
                address: vacancyDTO.address ?? vacancyDTO?.id === '' ? companyList.find(x => x.id === vacancyDTO?.companyId)?.address : vacancyDTO?.address,
                code: vacancyDTO.code && vacancyDTO.code !== '00000' ? vacancyDTO.code : (vacancyDTO?.id === '' ? companyList.find(x => x.id === vacancyDTO?.companyId)?.code + '-RS-' : ''),
            } as VacancyDTO);
        }
    }, [vacancyDTO?.companyId, vacancyDTO?.jobTitleId, vacancyDTO?.seniorityId]);

    const handleGetPermission = useCallback(async (featureId: string, setList: any) => {
        const accessRoleFilterDTO: AccessRoleFilterDTO = {
            featureId: featureId,
            userId: userInfo.user.id,
        };
        GenericService.PostGenericAsync1('authsphere.AccessRole', 'GetPermissionAsync', accessRoleFilterDTO, setActionExecuted, setLoading, undefined, setList,);
    }, []);

    const handleCompanyGetAll = useCallback(async () => {
        const companyFIlterDTO: CompanyFilterDTO = {
            name: '',
            businessRelationshipTypeId: '',
            statusId: '',
            where: `businessRelationshipTypeId IN ('${ListId.corpsphere.company.businessRelationshipType.customer}', '${ListId.corpsphere.company.businessRelationshipType.prospection}', '${ListId.corpsphere.company.businessRelationshipType.businessPartner}')`,
            orderBy: 'name ASC'
        };
        GenericService.GetAllAsync1('corpsphere.company', companyFIlterDTO, setLoading, setCompanyList, showMessage);
    }, []);

    const handlerUserGetAllAsync = useCallback(async (setUserList: any) => {
        const userFilterDTO: UserFilterDTO = {
            companyId: '',
            peopleId: '',
            userName: '',
            isServiceAccount: false
        };
        GenericService.GetAllViewAsync1('authsphere.user', userFilterDTO, setActionExecuted, setLoading, setUserList, showMessage, false);

    }, []);

    const handleRequesterGetAllAsync = useCallback(async () => {
        if (vacancyDTO?.companyId === undefined || vacancyDTO.companyId === '') {
            return;
        }
        const peopleFilterDTO: PeopleFilterDTO = {
            name: '',
            fullName: '',
            typeId: '',
            statusId: '',
            jobTitleId: '',
            companyId: vacancyDTO?.companyId,
            orderBy: 'fullName ASC',
            where: `typeId NOT IN ('${ListId.corpsphere.people.type.serviceAccount}')`
        };
        GenericService.GetAllAsync1('corpsphere.people', peopleFilterDTO, setLoading, setRequesterList, showMessage);
    }, [vacancyDTO?.companyId]);

    const handleServiceManagerGetAllAsync = useCallback(async () => {
        const peopleFilterDTO: PeopleFilterDTO = {
            name: '',
            fullName: '',
            typeId: '',
            statusId: '',
            jobTitleId: '',
            companyId: vacancyDTO?.companyId,
            orderBy: 'fullName ASC',
            // where: `typeId NOT IN ('${ListId.corpsphere.people.type.serviceAccount}')`
        };
        GenericService.GetAllAsync1('corpsphere.people', peopleFilterDTO, setLoading, setManagerList, showMessage);
    }, []);

    const handleRecruiterGetAllAsync = useCallback(async () => {
        const peopleFilterDTO: PeopleFilterDTO = {
            name: '',
            fullName: '',
            typeId: '',
            statusId: '',
            jobTitleId: '',
            orderBy: 'fullName ASC',
            where: `typeId NOT IN ('${ListId.corpsphere.people.type.serviceAccount}') AND jobTitleId IN ('${ListId.talentsphere.vacancy.jobTitle.recruitmentManagerId}', '${ListId.talentsphere.vacancy.jobTitle.recruiterId}')`
        };
        GenericService.GetAllAsync1('corpsphere.people', peopleFilterDTO, setLoading, setRecruiterList, showMessage);
    }, []);

    const handleListGetAll = useCallback(async (listId: string, setList: any, orderBy?: string) => {
        const valueListFilterDTO = {
            value: '',
            listId: listId,
            orderBy: orderBy ?? 'value ASC'
        };
        GenericService.GetAllAsync1(
            'parmsphere.valueList',
            valueListFilterDTO,
            setLoading,
            setList,
            showMessage
        );
    }, []);

    const handleGetVacancyByIdAsync = useCallback(async () => {
        GenericService.GetByIdAsync1('talentsphere.vacancy', data.id, setLoading, setVacancyDTO, showMessage);
    }, [data]);

    const handleSaveClick = useCallback(async () => {
        const dto = vacancyDTO as VacancyDTO;

        if (vacancyDTO?.id === '' || vacancyDTO?.id === undefined) {
            dto.createdById = userInfo.user.id;
            GenericService.AddAsync1('talentsphere.vacancy', dto, setVacancyDTO, setActionExecuted, setLoading, showMessage);
        }
        else {
            if (!accessRolePermissionDTO?.allowUpdate) {
                showMessage(t('vacancy.message.accessRolePermissionDTO'), 'info');
                return;
            }
            dto.updatedById = userInfo.user.id;
            GenericService.UpdateAsync1('talentsphere.vacancy', dto, setActionExecuted, setLoading, showMessage);
        }
    }, [vacancyDTO]);

    const handleCloneClick = useCallback(async () => {
        const dto = vacancyDTO as VacancyDTO;

        dto.createdById = userInfo.user.id;
        GenericService.CloneAsync1('talentsphere.vacancy', dto, setVacancyDTO, setActionExecuted, setLoading, showMessage);
    }, [vacancyDTO]);

    const hasSavedVacancy = Boolean(vacancyDTO?.id);

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        if (!hasSavedVacancy && Number(newValue) > 2)
            return;

        setValue(newValue);
    };

    function showMessage(message: string, type: 'error' | 'info' | 'success' | 'warning') {
        const msg: ISnackbarAlert = {
            id: 'message',
            message: message,
            type: type,
        };
        setSnackBarAlert(msg);
        setIsOpenMessage(true);

        if (type != 'success')
            setIsOpenMaintenance(true);
    }

    const actions: IDialogActions[] = [
        { id: 'save', text: t('vacancy.maintenanceButton.save'), icon: 'save_outlined', iconColor: 'primary', setAction: handleSaveClick, isClose: isOpenMaintenance },
        { id: 'duplicate', text: t('vacancy.maintenanceButton.duplicate'), icon: 'library_add_outlined', iconColor: 'warning', setAction: handleCloneClick, isClose: isOpenMaintenance },
        { id: 'close', text: t('resume.maintenanceButton.close'), icon: 'close_outlined', iconColor: 'secondary', setAction: () => void undefined },
    ];

    const chipStatus: IChipsSettingProps[] = [
        { value: 'New Request', iconName: 'person_add_alt_outlined', iconColor: 'primary' },
        { value: 'In Progress', iconName: 'manage_accounts_outlined', iconColor: 'info' },
        { value: 'Hired', iconName: 'person_outlined', iconColor: 'success' },
        { value: 'Canceled by the Contractor', iconName: 'person_off_outlined', iconColor: 'error' },
        { value: 'Suspended by the Contractor', iconName: 'person_add_disabled_outlined', iconColor: 'warning' },
        { value: 'Lost', iconName: 'person_off_outlined', iconColor: 'error' }
    ];
    return (
        <React.Fragment>
            {isOpenMessage && (
                <SnackbarAlert
                    snackBarAlert={snackBarAlert}
                    setIsOpen={setIsOpenMessage}
                    isOpen={isOpenMessage}
                />
            )}
            <DialogForm
                title={t('vacancy.detailsName')}
                icon='grid_view_outlined'
                setIsOpen={setIsOpenMaintenance}
                isOpen={isOpenMaintenance}
                fullWidth={true}
                maxWidth={'lg'}
                actions={actions}
                loading={loading}
            >
                <React.Fragment>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={12}>
                            <TabContext value={value} >
                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                    <TabList onChange={handleChange} aria-label="lab API tabs example">
                                        <Tab label={t('vacancy.tabItem.details')} value="1" />
                                        <Tab label={t('vacancy.tabItem.responsabilities')} value="2" />
                                        <Tab label={t('vacancy.tabItem.language')} value="3" disabled={!hasSavedVacancy} />
                                        <Tab label={t('vacancy.tabItem.hardSkill')} value="4" disabled={!hasSavedVacancy} />
                                        <Tab label={t('vacancy.tabItem.softSkill')} value="5" disabled={!hasSavedVacancy} />
                                        <Tab label={t('vacancy.tabItem.benefities')} value="6" disabled={!hasSavedVacancy} />
                                        <Tab label={t('vacancy.tabItem.additionalInformation')} value="7" disabled={!hasSavedVacancy} />
                                    </TabList>
                                </Box>
                                <TabPanel value="1" sx={{ ml: -3, mr: -3, mb: -3 }}>
                                    <Grid container spacing={2}>
                                        {vacancyDTO?.id ? (
                                            <Grid item xs={12} md={4}>
                                                <TextFieldReadOnly
                                                    id={'companyId'}
                                                    label='Company'
                                                    value={companyList.find(x => x.id === vacancyDTO.companyId)?.name}
                                                    hasDivider={true}
                                                    hasToolTip={true}
                                                />
                                            </Grid>
                                        ) : (
                                            <Grid item xs={12} md={4}>
                                                <SelectField
                                                    id='companyId'
                                                    label={t('vacancy.maintenance.company')}
                                                    placeholder={t('vacancy.maintenance.company')}
                                                    value={vacancyDTO?.companyId}
                                                    setValue={setVacancyDTO}
                                                    obj={vacancyDTO}
                                                    valueList={companyList}
                                                    required={false}
                                                    hasNoneSelect={false}
                                                    autoFocus={true}
                                                    readOnly={vacancyDTO?.id ? true : false}
                                                />
                                            </Grid>
                                        )}
                                        <Grid item xs={12} md={4}>
                                            <SelectField
                                                id='requesterId'
                                                label={t('vacancy.maintenance.requester')}
                                                placeholder={t('vacancy.maintenance.requester')}
                                                value={vacancyDTO?.requesterId}
                                                setValue={setVacancyDTO}
                                                obj={vacancyDTO}
                                                valueList={requesterList}
                                                required={false}
                                                hasNoneSelect={true}
                                                labelKey='fullName'
                                                valueKey='id'
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <SelectField
                                                id='managerId'
                                                label={t('vacancy.maintenance.manager')}
                                                placeholder={t('vacancy.maintenance.manager')}
                                                value={vacancyDTO?.managerId}
                                                setValue={setVacancyDTO}
                                                obj={vacancyDTO}
                                                valueList={managerList}
                                                required={false}
                                                hasNoneSelect={false}
                                                labelKey='fullName'
                                                valueKey='id'
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <TextFieldInput
                                                id='startHiring'
                                                label={t('vacancy.maintenance.startHiring')}
                                                value={vacancyDTO?.startHiring}
                                                setValue={setVacancyDTO}
                                                obj={vacancyDTO}
                                                required={false}
                                                type='datetime-local'
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <TextFieldInput
                                                id='numberOfVacancies'
                                                label={t('vacancy.maintenance.numberOfVacancies')}
                                                value={vacancyDTO?.numberOfVacancies}
                                                setValue={setVacancyDTO}
                                                obj={vacancyDTO}
                                                required={false}
                                                maxLength={2}
                                                numericOnly={true}
                                                valueType='text'
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <SelectField
                                                id='jobTitleId'
                                                label={t('vacancy.maintenance.jobTitle')}
                                                placeholder={t('vacancy.maintenance.jobTitle')}
                                                value={vacancyDTO?.jobTitleId}
                                                setValue={setVacancyDTO}
                                                obj={vacancyDTO}
                                                valueList={jobTitleList}
                                                required={false}
                                                hasNoneSelect={false}
                                                searchable={true}
                                                valueKey='id'
                                                labelKey={'value'}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <SelectField
                                                id='seniorityId'
                                                label={t('vacancy.maintenance.seniority')}
                                                placeholder={t('vacancy.maintenance.seniority')}
                                                value={vacancyDTO?.seniorityId}
                                                setValue={setVacancyDTO}
                                                obj={vacancyDTO}
                                                valueList={seniorityList}
                                                required={false}
                                                hasNoneSelect={false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <SelectField
                                                id='typeId'
                                                label={t('vacancy.maintenance.type')}
                                                placeholder={t('vacancy.maintenance.type')}
                                                value={vacancyDTO?.typeId}
                                                setValue={setVacancyDTO}
                                                obj={vacancyDTO}
                                                valueList={typeList}
                                                required={false}
                                                hasNoneSelect={false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <SelectField
                                                id='contractPeriodId'
                                                label={t('vacancy.maintenance.contractPeriod')}
                                                placeholder={t('vacancy.maintenance.contractPeriod')}
                                                value={vacancyDTO?.contractPeriodId}
                                                setValue={setVacancyDTO}
                                                obj={vacancyDTO}
                                                valueList={contractPeriodList}
                                                required={false}
                                                hasNoneSelect={false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <SelectField
                                                id='serviceLocalId'
                                                label={t('vacancy.maintenance.serviceLocal')}
                                                placeholder={t('vacancy.maintenance.serviceLocal')}
                                                value={vacancyDTO?.serviceLocalId}
                                                setValue={setVacancyDTO}
                                                obj={vacancyDTO}
                                                valueList={serviceLocalList}
                                                required={false}
                                                hasNoneSelect={false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <SelectField
                                                id='frequencyId'
                                                label={t('vacancy.maintenance.frequency')}
                                                placeholder={t('vacancy.maintenance.frequency')}
                                                value={vacancyDTO?.frequencyId}
                                                setValue={setVacancyDTO}
                                                obj={vacancyDTO}
                                                valueList={frequencyList}
                                                required={false}
                                                hasNoneSelect={true}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <SelectField
                                                id='workTypeId'
                                                label={t('vacancy.maintenance.workType')}
                                                placeholder={t('vacancy.maintenance.workType')}
                                                value={vacancyDTO?.workTypeId}
                                                setValue={setVacancyDTO}
                                                obj={vacancyDTO}
                                                valueList={workTypeList}
                                                required={false}
                                                hasNoneSelect={false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <SelectField
                                                id='serviceTypeId'
                                                label={t('vacancy.maintenance.serviceType')}
                                                placeholder={t('vacancy.maintenance.serviceType')}
                                                value={vacancyDTO?.serviceTypeId}
                                                setValue={setVacancyDTO}
                                                obj={vacancyDTO}
                                                valueList={serviceTypeList}
                                                required={false}
                                                hasNoneSelect={false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <SelectField
                                                id='hiringTypeId'
                                                label={t('vacancy.maintenance.hiringType')}
                                                placeholder={t('vacancy.maintenance.hiringType')}
                                                value={vacancyDTO?.hiringTypeId}
                                                setValue={setVacancyDTO}
                                                obj={vacancyDTO}
                                                valueList={hiringTypeList}
                                                required={false}
                                                hasNoneSelect={false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <TextFieldInput
                                                id='budgetEmployed'
                                                label={t('vacancy.maintenance.budgetEmployee')}
                                                value={vacancyDTO?.hiringTypeId === 'ba96d35e-318c-4baf-9583-1fbc3ab5421b' ? '' : vacancyDTO?.budgetEmployed}
                                                setValue={setVacancyDTO}
                                                obj={vacancyDTO}
                                                required={false}
                                                maxLength={20}
                                                numericOnly={true}
                                                valueType='currency'
                                                readonly={vacancyDTO?.hiringTypeId === 'ba96d35e-318c-4baf-9583-1fbc3ab5421b' ? true : false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <TextFieldInput
                                                id='budgetSelfEmployed'
                                                label={t('vacancy.maintenance.budgetSelfEmployee')}
                                                value={vacancyDTO?.hiringTypeId === 'c92ef6a8-477c-4812-9247-a97915eaf745' ? '' : vacancyDTO?.budgetSelfEmployed}
                                                setValue={setVacancyDTO}
                                                obj={vacancyDTO}
                                                required={false}
                                                maxLength={20}
                                                numericOnly={true}
                                                valueType='currency'
                                                readonly={vacancyDTO?.hiringTypeId === 'c92ef6a8-477c-4812-9247-a97915eaf745' ? true : false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <TextFieldReadOnly
                                                id={'code'}
                                                label={t('vacancy.maintenance.code')}
                                                value={(<ChipStatus label='Code' value={String(vacancyDTO?.code || '')} />)}
                                                hasDivider={false}
                                                hasToolTip={true}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <SelectField
                                                id='recruiterId'
                                                label={t('vacancy.maintenance.recruiter')}
                                                placeholder={t('vacancy.maintenance.recruiter')}
                                                value={vacancyDTO?.recruiterId}
                                                setValue={setVacancyDTO}
                                                obj={vacancyDTO}
                                                valueList={recruiterList}
                                                required={false}
                                                hasNoneSelect={false}
                                                labelKey='fullName'
                                                valueKey='id'
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <TextFieldInput
                                                id='openingDateTime'
                                                label={t('vacancy.maintenance.openingDate')}
                                                value={vacancyDTO?.openingDateTime}
                                                setValue={setVacancyDTO}
                                                obj={vacancyDTO}
                                                required={false}
                                                type='datetime-local'
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <TextFieldInput
                                                id='closingDateTime'
                                                label={t('vacancy.maintenance.closingDate')}
                                                value={vacancyDTO?.closingDateTime}
                                                setValue={setVacancyDTO}
                                                obj={vacancyDTO}
                                                required={false}
                                                type='datetime-local'
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <TextFieldReadOnly
                                                id={'address'}
                                                label={t('vacancy.maintenance.address')}
                                                value={vacancyDTO?.address}
                                                hasDivider={true}
                                                hasToolTip={true}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={10}>
                                            <TextFieldInput
                                                id='name'
                                                label={t('vacancy.maintenance.name')}
                                                placeholder={t('vacancy.maintenance.name')}
                                                value={vacancyDTO?.name}
                                                setValue={setVacancyDTO}
                                                obj={vacancyDTO}
                                                required={false}
                                                maxLength={100}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <TextFieldInput
                                                id='externalCode'
                                                label={t('vacancy.maintenance.externalCode')}
                                                placeholder={t('vacancy.maintenance.externalCode')}
                                                value={vacancyDTO?.externalCode}
                                                setValue={setVacancyDTO}
                                                obj={vacancyDTO}
                                                maxLength={10}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <TextFieldReadOnly
                                                id={'statusId'}
                                                label={t('resume.maintenance.status')}
                                                value={(<ChipStatus label='' value={statusList.find(x => x.id == vacancyDTO?.statusId)?.value ?? ''} chipSettings={chipStatus} />)}
                                                hasDivider={false}
                                            />
                                        </Grid><Grid item xs={12} md={2}>
                                            <CheckBoxComp
                                                id='hasBehavioralTest'
                                                label={t('vacancy.maintenance.behavioralTest')}
                                                setValue={setVacancyDTO}
                                                objDTO={vacancyDTO}
                                                defaultChecked={vacancyDTO?.hasBehavioralTest}
                                                disabled={false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <CheckBoxComp
                                                id='hasTechnicalTest'
                                                label={t('vacancy.maintenance.technicalTest')}
                                                setValue={setVacancyDTO}
                                                objDTO={vacancyDTO}
                                                defaultChecked={vacancyDTO?.hasTechnicalTest}
                                                disabled={false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <CheckBoxComp
                                                id='hasSituationalTest'
                                                label={t('vacancy.maintenance.situationalTest')}
                                                setValue={setVacancyDTO}
                                                objDTO={vacancyDTO}
                                                defaultChecked={vacancyDTO?.hasSituationalTest}
                                                disabled={false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <CheckBoxComp
                                                id='hasPraticalTest'
                                                label={t('vacancy.maintenance.praticalTest')}
                                                setValue={setVacancyDTO}
                                                objDTO={vacancyDTO}
                                                defaultChecked={vacancyDTO?.hasPraticalTest}
                                                disabled={false}
                                            />
                                        </Grid>
                                    </Grid>
                                </TabPanel>
                                <TabPanel value="2" sx={{ ml: -3, mr: -3, mb: -3 }}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={12}>
                                            <TextFieldInput
                                                id='responsibilities'
                                                label={t('vacancy.maintenance.responsabilities')}
                                                value={vacancyDTO?.responsibilities}
                                                setValue={setVacancyDTO}
                                                obj={vacancyDTO}
                                                required={false}
                                                multiline={true}
                                                rows={13}
                                            />
                                        </Grid>
                                    </Grid>
                                </TabPanel>
                                <TabPanel value="3" sx={{ ml: -3, mr: -3, mb: -3 }}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={12}>
                                            <DynamicComboBoxPair
                                                title={t('vacancy.maintenance.language.mandatorySkill')}
                                                ownerId={vacancyDTO?.id ?? data.id}
                                                skillType='language'
                                                isMandatory={true}
                                                hasValidated={false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <DynamicComboBoxPair
                                                title={t('vacancy.maintenance.language.optionalSkill')}
                                                ownerId={vacancyDTO?.id ?? data.id}
                                                skillType='language'
                                                isMandatory={false}
                                                hasValidated={false}
                                            />
                                        </Grid>
                                    </Grid>
                                </TabPanel>
                                <TabPanel value="4" sx={{ ml: -3, mr: -3, mb: -3 }}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={12}>
                                            <DynamicComboBoxPair
                                                title={t('vacancy.maintenance.hardSkill.mandatorySkill')}
                                                ownerId={vacancyDTO?.id ?? data.id}
                                                skillType='hardSkill'
                                                isMandatory={true}
                                                hasValidated={false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <DynamicComboBoxPair
                                                title={t('vacancy.maintenance.hardSkill.optionalSkill')}
                                                ownerId={vacancyDTO?.id ?? data.id}
                                                skillType='hardSkill'
                                                isMandatory={false}
                                                hasValidated={false}
                                            />
                                        </Grid>
                                    </Grid>
                                </TabPanel>
                                <TabPanel value="5" sx={{ ml: -3, mr: -3, mb: -3 }}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={12}>
                                            <DynamicComboBoxPair
                                                title={t('vacancy.maintenance.softSkill.mandatorySkill')}
                                                ownerId={vacancyDTO?.id ?? data.id}
                                                skillType='softSkill'
                                                isMandatory={true}
                                                hasValidated={false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <DynamicComboBoxPair
                                                title={t('vacancy.maintenance.softSkill.optionalSkill')}
                                                ownerId={vacancyDTO?.id ?? data.id}
                                                skillType='softSkill'
                                                isMandatory={false}
                                                hasValidated={false}
                                            />
                                        </Grid>
                                    </Grid>
                                </TabPanel>
                                <TabPanel value="6" sx={{ ml: -3, mr: -3, mb: -3 }}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={12}>
                                            <TextFieldInput
                                                id='benefits'
                                                label={t('vacancy.maintenance.benefits')}
                                                value={vacancyDTO?.benefits}
                                                setValue={setVacancyDTO}
                                                obj={vacancyDTO}
                                                required={false}
                                                multiline={true}
                                                rows={13}
                                            />
                                        </Grid>
                                    </Grid>
                                </TabPanel>
                                <TabPanel value="7" sx={{ ml: -3, mr: -3, mb: -3 }}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={12}>
                                            <TextFieldInput
                                                id='additionalInformation'
                                                label={t('vacancy.maintenance.additionalInformation')}
                                                value={vacancyDTO?.additionalInformation}
                                                setValue={setVacancyDTO}
                                                obj={vacancyDTO}
                                                required={false}
                                                multiline={true}
                                                rows={13}
                                            />
                                        </Grid>
                                    </Grid>
                                </TabPanel>
                            </TabContext>
                        </Grid>
                        {vacancyDTO?.id ? (
                            <React.Fragment>
                                <Grid item xs={12} md={4}>
                                    <TextFieldReadOnly
                                        id={'id'}
                                        label='Id'
                                        value={vacancyDTO.id}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'createdById'}
                                        label={t('vacancy.maintenance.createdBy')}
                                        value={userList.find(x => x.id === vacancyDTO.createdById)?.userName}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'creationDateTime'}
                                        label={t('vacancy.maintenance.creationDateTime')}
                                        value={formatDateTime(String(vacancyDTO.creationDateTime))}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'updatedById'}
                                        label={t('vacancy.maintenance.updatedBy')}
                                        value={userList.find(x => x.id === vacancyDTO.updatedById)?.userName}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'updateDateTime'}
                                        label={t('vacancy.maintenance.updateDateTime')}
                                        value={formatDateTime(String(vacancyDTO.updateDateTime))}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                            </React.Fragment>
                        ) : undefined}
                    </Grid>
                </React.Fragment>
            </DialogForm>
        </React.Fragment>
    );
};
